<div class="business-menu post-box-shadow cursor-ponit hpanel community-header-sticker">
 <div class="pad-0 border-radius-top-left-right-6">
  <ul id="grouplist side-menu" class="list-group nav custom-post-menu">
    <ng-container>
      <li class="list-group-item cursor-ponit mr-3" [ngClass]="{'active':commondata.menu=='communityhome'}"
        (click)="menuclick('communityhome')">
        <span class="nav-label">Home </span>
      </li>
      <li class="list-group-item cursor-ponit mr-3" [ngClass]="{'active':commondata.menu=='communityabout'}"
        (click)="menuclick('communityabout')" routerLinkActive="router-link-active">
        <span class="nav-label"> About us </span>
      </li>
      <div>
        <div class="ty">
          <div class="br-none business-menu-dropdown mr-br-3 menu-dropdown-flex" [ngClass]="{'subactive':commondata.menu=='memberspage'}">

            <div *ngIf="!communityType" class="cursor-ponit full-width" (click)="comMethod('memberspage')"
              routerLinkActive="active">
              Members
              <span *ngIf="values.joinReqCnt > 0 && ( isAdmin === 'true' || isCommunitySuperAdmin === 'true')"
                class="join-req">{{ values.joinReqCnt}}</span>
            </div>
            <div
              *ngIf="communityType && ( isAdmin === 'true' || isCommunitySuperAdmin === 'true' || isJoined == 'true')"
              class="cursor-ponit full-width" (click)="comMethod('memberspage')" routerLinkActive="active">
              <span class="nav-label">Members</span>
              <span *ngIf="values.joinReqCnt > 0 && (isAdmin === 'true' || isCommunitySuperAdmin === 'true') "
                class="join-req">{{ values.joinReqCnt}}</span>
            </div>
            <div
              *ngIf="communityType && (isJoined === 'false' && isAdmin === 'false' && isCommunitySuperAdmin === 'false')"
              routerLinkActive="active"> Members
            </div>
            <div class="panel-tools" *ngIf="commondata.adminviewnavigation && membersflage==true">
              <a (click)="communitymembers = !communitymembers" [attr.aria-expanded]="!communitymembers">
                <!-- <ng-icon name="tablerChevronDown" *ngIf="communitymembers"></ng-icon> -->
                <!-- <ng-icon name="tablerChevronUp" *ngIf="!communitymembers"></ng-icon> -->
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="custom-panel" *ngIf=" commondata.adminviewnavigation && membersflage==true"
          [collapse]="communitymembers" [isAnimated]="true">
          <ul id="grouplist" class="list-group cursor-ponit ">
            <ng-container>
              <li class=" list-group-item mr-br-3 line_bw active cursor-ponit" *ngIf="communityType"
                [ngClass]="{'subactive':commondata.menu=='request'}" (click)="menuclick('request')"
                routerLinkActive="router-link-active" class="common-font-12"> Request received -->
                <!-- <button class="btn btn-danger c-button joinreqcnt" style="border-radius: 15px !important;" type="button"
                      *ngIf="values.joinReqCnt > 0"> -->
                <!-- <span *ngIf="values.joinReqCnt > 0" class="join-req">{{ values.joinReqCnt}}</span> -->
                <!-- </button> -->
              <!-- </li>
              <li class="list-group-item mr-3 common-font-12 cursor-ponit" [ngClass]="{'subactive':commondata.menu=='Invite'}"
                style="border: none;" (click)="menuclick('Invite')"
                routerLinkActive="router-link-active">Invite Members
              </li>
            </ng-container>
          </ul>
        </div> -->
        <div *ngIf=" commondata.adminviewnavigation && membersflage==true">
          <div class="hr-react oiu menu-dropdown-flex" (click)="communitymanagepage = !communitymanagepage"
            [attr.aria-expanded]="!communitymanagepage" [ngClass]="{'subactive':commondata.menu=='managepages'}">

            <div class="cursor-ponit"> Manage Page </div>
            <div class="panel-tools">
              <svg class="menu-chevron" [class.collapsed]="communitymanagepage" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="none"/>
                <path d="M7 14.5L12 9.5L17 14.5" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="custom-panel" [collapse]="communitymanagepage" [isAnimated]="true">
            <ul id="grouplist" class="list-group cursor-ponit">
              <ng-container>
                <li class="list-group-item mr-br-3 line_bw cursor-ponit common-font-12"
                  [ngClass]="{'subactive':commondata.menu=='communitypageadmin'}"
                  (click)="menuclick('communitypageadmin')" routerLinkActive="router-link-active" >
                  Page Admins
                </li>
                <li class="list-group-item mr-br-3 cursor-ponit common-font-12" [ngClass]="{'subactive':commondata.menu=='deactivate'}"
                  style="border: none;" (click)="menuclick('deactivate')"
                  *ngIf="isSuperAdmin === 'true'" routerLinkActive="router-link-active">Deactivate Community
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
  </ul>
 </div>
</div>
